<section class="about" id="about">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-5">
                <h2 class="section-title">{{'about.title' | translate }}</h2>
                <h4 class="section-sub-title">{{ 'about.sub_title' | translate }} </h4>
            </div>
            <div class="col-12 col-lg-7 px-lg-0">
                <p class="section-desc text-start mb-5">{{ 'about.desc' | translate }} </p>
                <p class="section-desc text-start mb-5">{{ 'about.desc_2' | translate }} </p>
                <p class="section-desc text-start">{{ 'about.desc_3' | translate }} </p>
                <div class="d-flex align-items-center justify-content-center gap-3 flex-wrap my-5">
                    <div class="wings wings_1">
                        <div class="wings-title">{{'about.wings_1_title' | translate}}</div>
                        <p>{{ 'about.wings_1_desc' | translate }}</p>
                    </div>
                    <div class="wings wings_2">
                        <div class="wings-title">{{'about.wings_2_title' | translate}}</div>
                        <p>{{'about.wings_2_desc' | translate}}</p>
                    </div>
                    <div class="wings wings_3">
                        <div class="wings-title">{{'about.wings_3_title' | translate}}</div>
                        <p>{{'about.wings_3_desc' | translate}}</p>
                    </div>
                    <div class="wings wings_4">
                        <div class="wings-title">{{'about.wings_4_title' | translate}}</div>
                        <p>{{'about.wings_4_desc' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-12 d-none d-lg-block my-4"></div>
            <div class="col-12 col-lg-5">
                <h2 class="section-title">{{'about.title_2' | translate }}</h2>
                <h4 class="section-sub-title">{{ 'about.sub_title' | translate }} </h4>
            </div>
            <div class="col-12 col-lg-7">
                <p class="section-desc text-start"> {{'about.desc_4' | translate}}</p>
            </div>
        </div>
        <div class="circle circle_1"></div>
        <div class="circle circle_2"></div>
    </div>

</section>